import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bulk-actions mb-4" }
const _hoisted_2 = { class: "bulk-btn-text" }
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "price-selection-table" }
const _hoisted_5 = { class: "td-part-number" }
const _hoisted_6 = { class: "part-number" }
const _hoisted_7 = { class: "td-pricelists" }
const _hoisted_8 = { class: "pricelist-options" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = ["name", "value", "checked", "onChange"]
const _hoisted_11 = { class: "pricelist-price" }
const _hoisted_12 = { class: "td-selected" }
const _hoisted_13 = {
  key: 0,
  class: "selected-indicator"
}
const _hoisted_14 = {
  key: 1,
  class: "manual-indicator"
}
const _hoisted_15 = {
  key: 2,
  class: "not-selected"
}
const _hoisted_16 = { class: "selection-summary mt-4" }
const _hoisted_17 = { class: "summary-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createBlock(_component_AppDialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "Select Prices from Multiple Pricelists",
    icon: "mdi-tag-multiple-outline",
    "max-width": "1200",
    persistent: "",
    "cancel-text": "Cancel",
    "confirm-text": "Apply Selections",
    "confirm-disabled": !_ctx.hasChanges,
    onConfirm: _ctx.confirmSelection,
    onCancel: _ctx.cancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "bulk-label" }, "Select all prices from:", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePricelists, (pricelistName, index) => {
            return (_openBlock(), _createBlock(_component_v_tooltip, {
              key: pricelistName,
              location: "bottom",
              "open-delay": 1000
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({
                  size: "small",
                  variant: "outlined",
                  class: ['ml-2', 'bulk-btn', `bulk-btn-${_ctx.getColorClass(index)}`],
                  ref_for: true
                }, props, {
                  onClick: ($event: any) => (_ctx.selectAllFromPricelist(pricelistName))
                }), {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(pricelistName), 1)
                  ]),
                  _: 2
                }, 1040, ["class", "onClick"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(pricelistName), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _createVNode(_component_v_divider, { class: "mb-4" }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "th-part-number" }, "Part Number"),
                _createElementVNode("th", { class: "th-pricelists" }, "Available Prices"),
                _createElementVNode("th", { class: "th-selected" }, "Selected")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saleLinesWithPricelists, (line) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: line.id
                }, [
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(line.partNumber), 1)
                  ]),
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.multiplePriceLists, (pl) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: pl.priceListId,
                          class: _normalizeClass(["pricelist-card", [
                        `pricelist-card-${_ctx.getColorClassByPricelist(pl)}`,
                        {
                          selected:
                            _ctx.selections[line.id]?.type === 'pricelist' && _ctx.selections[line.id]?.priceListId === pl.priceListId,
                        },
                      ]])
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_v_tooltip, {
                              location: "bottom",
                              "open-delay": 1000
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("span", _mergeProps({ ref_for: true }, props, {
                                  class: ['pricelist-badge', `pricelist-badge-${_ctx.getColorClassByPricelist(pl)}`]
                                }), _toDisplayString(pl.priceListTag || pl.priceListName), 17)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(pl.priceListTag || pl.priceListName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("input", {
                              type: "radio",
                              name: `price-${line.id}`,
                              value: pl.priceListId,
                              checked: 
                            _ctx.selections[line.id]?.type === 'pricelist' && _ctx.selections[line.id]?.priceListId === pl.priceListId
                          ,
                              onChange: ($event: any) => (_ctx.selectPricelist(line.id, pl))
                            }, null, 40, _hoisted_10)
                          ]),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatCurrency(pl.enginePrice)), 1)
                        ], 2))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_12, [
                    (_ctx.selections[line.id]?.type === 'pricelist')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.formatCurrency(_ctx.selections[line.id]?.price)), 1))
                      : (_ctx.selections[line.id]?.type === 'manual' && _ctx.selections[line.id]?.manualPrice)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.formatCurrency(_ctx.selections[line.id]?.manualPrice)), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, "--"))
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.selectedCount), 1),
            _cache[3] || (_cache[3] = _createTextVNode(" of ")),
            _createElementVNode("strong", null, _toDisplayString(_ctx.saleLinesWithPricelists.length), 1),
            _cache[4] || (_cache[4] = _createTextVNode(" prices selected "))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "confirm-disabled", "onConfirm", "onCancel"]))
}